<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover()" (mouseleave)="mouseOut()">

    <div class="navbar-header pt-3 mb-2 mb-xl-4 "[ngClass]="{ 'mb-xl-4': !miniAndMaxiSideBar }" >
      <div class="position-absolute close-ic" *ngIf="isCloseButtonShow()" (click)="closeSidebar($event)">
        <img src="assets/images/icons/close_icon.svg" alt="">
      </div>
      <div class="position-absolute close-ic" >
        <i class="material-icons hover-ic" *ngIf="!miniAndMaxiSideBar && !minMaxByWindowWidth" (click)="minimizeMaximizeSidebar(false)">chevron_left</i>
        <i class="material-icons hover-ic" *ngIf="miniAndMaxiSideBar && !minMaxByWindowWidth" (click)="minimizeMaximizeSidebar(false)">chevron_right</i>
      </div>
      <ul class="nav navbar-nav flex-row">

        <li class="nav-item logo" *ngIf="groupType != 'individual' && groupType != 'manager'">
          <a class="navbar-brand ms-0 ml-0" routerLink="dashboard/dashboard2">
            <img src="assets/images/logo/logo.svg" class="img-fluid">
          </a>
          <a class=" ms-0 ml-0" *ngIf="!miniAndMaxiSideBar" routerLink="dashboard/dashboard2">
            <img src="assets/images/logo/text_logo.svg" class="img-fluid" alt="">
          </a>
        </li>

        <li class="nav-item logo" *ngIf="groupType == 'individual'">
          <a class="navbar-brand ms-0 ml-0" routerLink="individual/dashboard">
            <img src="assets/images/logo/logo.svg" class="img-fluid">
          </a>
          <a class=" ms-0 ml-0" routerLink="individual/dashboard">
            <img src="assets/images/logo/text_logo.svg" class="img-fluid" alt="">
          </a>
        </li>

        <li class="nav-item logo" *ngIf="groupType == 'manager'">
          <a class="navbar-brand ms-0 ml-0" routerLink="manager/dashboard">
            <img src="assets/images/logo/logo.svg" class="img-fluid">
          </a>
          <a class=" ms-0 ml-0" routerLink="manager/dashboard">
            <img src="assets/images/logo/text_logo.svg" class="img-fluid" alt="">
          </a>
        </li>

      </ul>
    </div>
    <!-- Menu -->

    <div class="menu">
      <ng-scrollbar [style.height]="listMaxHeight + 'px'" visibility="hover">
        <ul class="list" id="menu-item">
          <!-- Top Most level menu -->
          <li *ngFor="let sidebarItem of sidebarItems ,let i = index"
            [routerLinkActive]="sidebarItem.submenu.length !== 0 ? 'active' : 'active-top'">
            <!-- <div *ngxPermissionsOnly="sidebarItem.itemName"> -->
            <!-- <div class="header" *ngIf="sidebarItem.groupTitle === true">{{sidebarItem.title | translate}}</div> -->

            <!-- this is for maximize view -->
            <div *ngIf="showItem(i) && !this.miniAndMaxiSideBar">
              <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
                *ngIf="!sidebarItem.groupTitle && sidebarItem.is_access"
                [ngClass]="[
                sidebarItem.class, 
                miniAndMaxiSideBar ? 'minimizedItem' : '' ,
                groupType != 'individual' && 
                groupType != 'manager' && 
                sidebarItem.itemName != 'dashboard' && 
                !miniAndMaxiSideBar && 
                sidebarItem.itemName != 'user_management' ? 'p-l-35' : '']"
                (click)="callToggleMenu($event, sidebarItem.submenu.length);" class="menu-top">
                <ng-container [ngTemplateOutlet]="mainRoute"
                  [ngTemplateOutletContext]="{ sidebarItem:sidebarItem  }"></ng-container>
              </a>

              <a *ngIf="!sidebarItem.groupTitle && !sidebarItem.is_access"
                [ngClass]="[
                sidebarItem.class, 
                miniAndMaxiSideBar ? 'minimizedItem' : '',   
                groupType != 'individual' && 
                groupType != 'manager' && 
                sidebarItem.itemName != 'dashboard' && 
                !miniAndMaxiSideBar && 
                sidebarItem.itemName != 'user_management' ? 'p-l-35' : '']"
                (click)="goToRouteNew($event,sidebarItem.submenu.length,sidebarItem.path,sidebarItem)" class="menu-top">
                <ng-container [ngTemplateOutlet]="mainRoute"
                  [ngTemplateOutletContext]="{ sidebarItem:sidebarItem }"></ng-container>
              </a>
            </div>

            <!-- this is for minimize view -->
            <div *ngIf="this.miniAndMaxiSideBar">
              <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
                *ngIf="!sidebarItem.groupTitle && sidebarItem.is_access"
                [ngClass]="[
                sidebarItem.class, 
                miniAndMaxiSideBar ? 'minimizedItem' : '' ,
                groupType != 'individual' && 
                groupType != 'manager' && 
                sidebarItem.itemName != 'dashboard' && 
                !miniAndMaxiSideBar && 
                sidebarItem.itemName != 'user_management' ? 'p-l-35' : '']"
                (click)="callToggleMenu($event, sidebarItem.submenu.length)" class="menu-top">
                <ng-container [ngTemplateOutlet]="mainRoute"
                  [ngTemplateOutletContext]="{ sidebarItem:sidebarItem  }"></ng-container>
              </a>

              <a *ngIf="!sidebarItem.groupTitle && !sidebarItem.is_access"
                [ngClass]="[
                sidebarItem.class, 
                miniAndMaxiSideBar ? 'minimizedItem' : '',   
                groupType != 'individual' && 
                groupType != 'manager' && 
                sidebarItem.itemName != 'dashboard' && 
                !miniAndMaxiSideBar && 
                sidebarItem.itemName != 'user_management' ? 'p-l-35' : '']"
                (click)="goToRouteNew($event,sidebarItem.submenu.length,sidebarItem.path,sidebarItem)" class="menu-top">
                <ng-container [ngTemplateOutlet]="mainRoute"
                  [ngTemplateOutletContext]="{ sidebarItem:sidebarItem  }"></ng-container>
              </a>
            </div>

            <!-- First level menu -->
            <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0 && !this.miniAndMaxiSideBar && !toggleSidebarSubMenu">
              <li *ngFor="let sidebarSubItem1 of sidebarItem.submenu"
                [routerLinkActive]="sidebarSubItem1.submenu.length > 0 ? '' : 'active'">
                <a [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : [sidebarSubItem1.path]"
                  *ngIf="sidebarSubItem1.is_access" (click)="callToggleMenu($event,sidebarSubItem1.submenu.length)"
                  [ngClass]="[sidebarSubItem1.class]">
                  <!-- {{sidebarSubItem1.icon}} -->
                  {{sidebarSubItem1.title | translate}} 
                </a>

                <a *ngIf="!sidebarSubItem1.groupTitle && !sidebarSubItem1.is_access" [ngClass]="[sidebarSubItem1.class]"
                  (click)="goToRouteNew($event,sidebarSubItem1.submenu.length,sidebarSubItem1.path,sidebarSubItem1)">
                  {{sidebarSubItem1.title | translate}}
                </a>
                <!-- <a [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : [sidebarSubItem1.path]"
                  (click)="callToggleMenu($event,sidebarSubItem1.submenu.length)" [ngClass]="[sidebarSubItem1.class]">
                  {{sidebarSubItem1.title | translate}}
                </a> -->
                <!-- Second level menu -->
                <ul class="ml-menu-2" *ngIf="sidebarSubItem1.submenu.length > 0">
                  <li *ngFor="let sidebarSubItem2 of sidebarSubItem1.submenu"
                    [routerLinkActive]="sidebarSubItem2.submenu.length > 0 ? '' : 'active'">
                    <a [routerLink]="sidebarSubItem2.submenu.length > 0 ? null : [sidebarSubItem2.path]"
                      (click)="callToggleMenu($event,sidebarSubItem2.submenu.length)"
                      [ngClass]="[sidebarSubItem2.class]">
                      {{sidebarSubItem2.title | translate}}
                    </a>
                    <!-- Third level menu -->
                    <ul class="ml-menu-3" *ngIf="sidebarSubItem2.submenu.length > 0">
                      <li *ngFor="let sidebarSubItem3 of sidebarSubItem2.submenu"
                        [routerLinkActive]="sidebarSubItem3.submenu.length > 0 ? '' : 'active'">
                        <a [routerLink]="sidebarSubItem3.submenu.length > 0 ? null : [sidebarSubItem3.path]"
                          (click)="callToggleMenu($event,sidebarSubItem3.submenu.length)"
                          [ngClass]="[sidebarSubItem3.class]">
                          {{sidebarSubItem3.title | translate}}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>

            <!-- <ng-container  >
              <div class="side-title">{{sidebarItem.itemName}}</div>
            </ng-container> -->
            <!-- <ng-container *ngIf="sidebarItem.itemName == 'user_management'" >
              <div class="side-title">Univate LMS</div>
            </ng-container>
            <ng-container *ngIf="sidebarItem.itemName == 'upload_document'" >
              <div class="side-title">Univate Time Keeping</div>
            </ng-container> -->

            <div class="ex-button position-relative" [ngClass]="{ 'ex-b-bg': !hideBetweenUserAndUpload }"
              *ngIf="sidebarItem.itemName === 'user_management'  && groupType != 'manager' && !miniAndMaxiSideBar" (click)="toggleAfterUserManagement(i)"
              style="cursor: pointer;">
              <div class="d-flex gap-2"> <img src="assets/images/sidebar/manage_package.svg" alt=""> Univate LMS</div>
              <span class="arrow" [ngClass]="{ 'down': hideBetweenUserAndUpload }"></span>
            </div>

            <div class="ex-button position-relative" [ngClass]="{ 'ex-b-bg': !hideAfterUploadDocument }"
              *ngIf="sidebarItem.itemName === 'upload_document' && groupType != 'manager' && !miniAndMaxiSideBar" (click)="toggleAfterUserManagement(i)"
              style="cursor: pointer;">
              <div class="d-flex gap-2"> <img src="assets/images/sidebar/manage_package.svg" alt=""> Univate Time
                Keeping</div>
              <span class="arrow" [ngClass]="{ 'down': hideAfterUploadDocument }"></span>
            </div>
            <!-- </div> -->
          </li>
        </ul>
      </ng-scrollbar>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
<!-- [ngClass]="{'minimizedItem':!miniAndMaxiSideBar}" -->

<ng-template #mainRoute let-sidebarItem="sidebarItem">
  <img [src]="sidebarItem.icon" [title]="sidebarItem.title | translate" alt="">
  <img [src]="" alt="">
  <span class="hide-menu" *ngIf="!miniAndMaxiSideBar"  >{{sidebarItem.title | translate}}</span>
  <span *ngIf="sidebarItem.badge !== '' " [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
</ng-template>